export default __webpack_public_path__ + "static/media/tron-foundation.73ffdc35.svg";